import React, {useEffect, useRef} from 'react';
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";


const StyledSlidingModal = styled.div<{ top: string }>`
    transform: translateX(100%);
    position: fixed;
    top: ${(props) => (props.top ? props.top : "53px")};
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background: ${({theme}) => theme.colors.background};
    z-index: 9;
    transition: transform 250ms ease-in-out;
    //Чтобы клики не проходили, пока модалка не открыта:
    pointer-events: none;
    height: calc(100vh - ${props => props.top ? props.top : '0px'});
    overflow-y: hidden;

    &.${GLOBAL_STYLE_CONFIG.splitByPrefix("sliding-modal-open")} {
        transform: translateX(0);
        pointer-events: auto;
    }

`

interface IProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    top: number;
}

const SlidingModal: React.FC<IProps> = ({isOpen, onClose, children, top = 0}) => {
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (!isOpen) return;
            const target = e.target as HTMLElement;
            //@ts-expect-error
            if (ref.current && !ref.current.contains(target)) {
                onClose();
            }
        };

        document.body.addEventListener('click', handleClickOutside);
        return () => document.body.removeEventListener('click', handleClickOutside);
    }, [isOpen, onClose]);

    useEffect(() => {
        document.body.style.overflowY = isOpen ? 'hidden' : 'auto';
    }, [isOpen]);

    return (
        <StyledSlidingModal className={isOpen ? GLOBAL_STYLE_CONFIG.splitByPrefix('sliding-modal-open') : ''} top={`${top}px`}
                            ref={ref}>
            {children}
        </StyledSlidingModal>
    );
};

export default SlidingModal;